import React from 'react';
import PropTypes from 'prop-types';
import { Controller } from 'react-hook-form';
import { FormError } from '@ds/react-components';

import * as Styled from './CancelFeeDeclaration.styled';

const CancelFeeDeclaration = (props) => {
  const {
    formControl,
    cancelFeeLimit,
    cancellationFeeValue,
    cancellationFeeError,
    declarationError,
  } = props;

  return !cancelFeeLimit ? (
    <Controller
      name={'cancellationFeeDeclaration'}
      control={formControl}
      //Required only if the cancellation fee has been entered.
      rules={{
        required: cancellationFeeValue
          ? 'You cannot continue without agreeing to the declaration'
          : false,
      }}
      render={({ onChange, value, onBlur }) => (
        <Styled.DeclarationContainer>
          <Styled.DeclarationText>
            {'The Facility agrees that in the event of a dispute arising that is directly or indirectly related ' +
              'to the imposition of this fee, it will, within 48 hours of a request by Debitsuccess, provide Debitsuccess with the evidence required to substantiate the customer’s acceptance of this fee. In addition, the Facility agrees that it will be solely responsible to the customer for any ' +
              'and all losses, costs, actions, demands, expenses or other liabilities arising, as a result of the imposition of this fee.'}
          </Styled.DeclarationText>
          <Styled.DeclareCheckbox
            label={'I agree to the above declaration'}
            checked={value}
            onChange={(event) => onChange(event.target.checked)}
            disabled={!cancellationFeeValue || !!cancellationFeeError}
            onBlur={onBlur}
          />
          {declarationError && declarationError.message && (
            <FormError>{declarationError.message}</FormError>
          )}
        </Styled.DeclarationContainer>
      )}
    />
  ) : (
    <React.Fragment />
  );
};

CancelFeeDeclaration.propTypes = {
  cancelFeeLimit: PropTypes.number,
  formControl: PropTypes.object,
  cancellationFeeValue: PropTypes.number, //The value entered in the cancellation fee input.
  cancellationFeeError: PropTypes.object,
  declarationError: PropTypes.shape({
    message: PropTypes.string,
  }),
};

export default CancelFeeDeclaration;
